<template>
  <div class="uplaod">
    <div class="titleArea">
      <span v-if="info.isRequire">*</span>
      <div class="title">{{ info.fileTitle }}</div>
      <div class="format" v-if="!hideTip">
        注：<template v-if="info.titleNotes">{{ info.titleNotes }}，</template>
        <template v-if="info.typeNotes">{{ info.typeNotes }}，</template>
        <template v-if="info.fileNumber">最多上传{{ info.fileNumber }}个文件，</template>
        <template v-if="info.fileSize">单个最大上传{{ info.fileSize }}M的文件</template>
      </div>
    </div>
    <!-- <div class="tip">
      注：{{ info.typeNotes }}，最多上传{{ info.fileNumber }}个文件
    </div> -->
    <div class="uploadAction">
      <!-- {{ fileList[fileList.length - 1] }} -->
      <div class="desc" v-if="info.isInput === 1">
        <span>说明：</span>
        <a-input v-model="desc" @input="handelInput" style="width: 500px;" />
      </div>
      <a-upload
          :disabled="state==2 || disabled"
          name="file"
          :fileList="fileList"
          :accept="info.fileType"
          :multiple="true"
          :beforeUpload="beforeUpload"
          :action="`${axios.defaults.baseURL}/common/upload`"
          :headers="headers"
          :remove="remove"
          @change="handleChange"
          class="uploader"
      >
        <div class="uploadBtn">
          <img src="../../../assets/images/uploadicon.png" alt="" />
          <span>点击上传</span>
        </div>
      </a-upload>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      headers: { "X-Access-Token": localStorage.getItem("token") },
      desc: "",
      fileList: []
    };
  },
  props: {
    disabled: {
      type: Boolean,
      default: false
    },
    required: {
      type: Boolean,
      default: false
    },
    state: {
      type: Number,
      default: 0
    },
    info: {
      type: Object,
      default: () => {}
    },
    hideTip: {
      type: Boolean,
      default: false
    }
  },
  watch: {
    "info.fileList": {
      handler(val) {
        this.fileList = val.map(item => {
          const obj = {
            uid: item.id,
            id: item.id,
            status: "done",
            size: item.fileSize,
            name: item.docName,
            url: item.docUrl
          };
          this.$emit("change", {
            configId: this.info.id,
            file: obj
          });
          return obj;
        });
      },
      immediate: true
    }
  },
  created() {
    if (this.info.isInput === 1) {
      this.desc = (this.info.fileList[0] || {}).remark || "";
    }
  },
  methods: {
    clearFiles() {
      this.fileList = [];
    },
    handleChange(info) {
      if (info.file.status === "done") {
        const index = this.fileList.findIndex(
            item => item.uid === info.file.uid
        );
        if (info.file.response.code === 200) {
          this.fileList[index].status = "done";
          this.fileList[index].url = info.file.response.result;
          this.fileList[index].remark = this.desc;
          this.$emit("change", {
            configId: this.info.id,
            file: this.fileList[index]
          });
          this.$message.success(`${info.file.name}上传成功`);
        } else {
          this.fileList[index].status = "error";
          this.fileList.splice(index, 1);
          this.$message.error(info.file.response.message);
        }
      } else if (info.file.status === "error") {
        const index = this.fileList.findIndex(
            item => item.uid === info.file.uid
        );
        this.fileList[index].status = "error";
        this.$message.error(`${info.file.name}上传失败`);
      }
    },
    beforeUpload(file) {
      if (this.info.fileSize) {
        const isLt2M = file.size / 1024 / 1024 < this.info.fileSize;
        if (!isLt2M) {
          this.$message.error(`只能上传小于${this.info.fileSize}MB的文档！`);
          return false;
        }
      }
      if (this.info.fileNumber) {
        if (this.fileList.length >= this.info.fileNumber) {
          this.$message.error("最多只能上传" + this.info.fileNumber + "个文件");
          return false;
        }
      }
      const type = file.name.substr(file.name.lastIndexOf(".")).toLowerCase();
      if (!this.info.fileType || this.info.fileType.includes(type)) {
        this.fileList.push({
          uid: file.uid,
          status: "uploading",
          size: (file.size / 1024 / 1024).toFixed(2),
          name: file.name,
          url: ""
        });
        return true;
      } else {
        this.$message.error("上传文件格式错误");
        return false;
      }
    },
    remove(file) {
      const index = this.fileList.findIndex(item => item.uid === file.uid);
      this.fileList.splice(index, 1);
      this.$emit("remove", {
        id: file.id,
        uid: file.uid
      });
      // if (file.id) {
      //   this.$emit("remove", file.id);
      // }
    },
    handelInput() {
      this.$emit("changeDesc", {
        configId: this.info.id,
        desc: this.desc
      });
    }
  }
};
</script>

<style lang="scss" scoped>
.uplaod {
  font-size: 14px;
  margin-bottom: 8px;
  border-bottom: 1px solid #eee;
  padding: 16px;

.titleArea {
  display: flex;

.title {
  margin: 0 8px;
}

span,
.format {
  color: red;
}
}

.tip {
  margin: 8px 0;
  color: red;
}

.uploadAction {
  margin: 16px 0;
.uploader {
  display: flex;
  gap: 24px;
.uploadBtn {
  background: #ffffff;
  border-radius: 10px;
  border: 1px solid #e5e9e9;
  height: 80px;
  width: 400px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
span {
  margin-top: 8px;
}
}
}
.desc {
  margin-bottom: 8px;
  display: flex;
  align-items: center;
span {
  margin-left: 13px;
  width: 60px;
}
}
}
}
</style>

<style lang="scss">
.ant-upload-list {
  width: 600px;
  max-height: 80px;
  overflow-y: auto;
.ant-upload-list-item-name {
  color: #2caf7a;
}
.ant-upload-list-item-error {
.ant-upload-list-item-name {
  color: #f5222d;
}
}
}
</style>



// WEBPACK FOOTER //
// src/pages/PracticeDetail/components/docListUpload.vue